import React from 'react';
import '../../utility/csrf';
import AmountWrapper from '../../components/amountWrapper';
import NextButton from '../../components/nextButton';
import OneTouchNextButton from '../../components/landing/OneTouchNextButton';
import CancelAndReturn from '../../components/cancelAndReturn';
import GuestButton from '../../components/guestButton';
import RecurringCheckBox from '../../components/recurring-checkbox/recurring-checkbox';
import UserDetailsBanner from '../../components/onetouch/UserDetailsBanner';
import OfferDetail from '../../components/offerDetail';
import Disclaimer from '../../components/Disclaimer';
import VoucherFlowDisclaimer from '../../components/voucherFlowDisclaimer';
import CloseButton from '../../components/CloseButton';
import ReceiverEligibilityErrorTile from '../error/receiverEligibilityError';
import {
  isInContext,
  isMobileOrInContext,
} from '../../utility/inContextDonation';
import DonateHeader from '../../components/common/DonateHeader';

import templateData from '../../utility/getTemplateData';
import {
  hasPersonalizedMessages,
  getPersonalizedMessages,
} from '../../utility/personalizedMessages';

import AppStore from '../../stores/AppStore';
import * as AppActions from '../../actions/AppActions';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import * as cpl from '../../utility/cpl';
import { GN_CONTENT_TOUCHPOINT } from '../../utility/constants';

import {
  handleLogIn,
  addShake,
  handleTokenReuse,
  hideSpinnerOverlay,
  getPPCCStatus,
  showSpinnerOverlay,
} from '../../utility/helper';
import {
  isAuthenticatedUser,
  shouldShowUserBanner,
  isLoggedInUser,
} from '../../utility/authUtils';
import * as amountUtils from '../../components/amount/amountUtils';

import { withRouter } from 'react-router-dom';
import {
  localsMessages,
  isOldButtonFactory,
  hasPartnerSource,
} from '../../utility/getTemplateData';
import { isCampaigns } from '../../utility/productIntegrationUtils';
import { loadBodyMovin } from '../../utility/lazyLoader';
import _isEmpty from 'lodash/isEmpty';
import Programs from '../../components/programs/Programs';
import RecurringOverlay from '../../components/recurring-checkbox/RecurringOverlay';
import _get from 'lodash/get';
import NotTaxDeductibleLegalText from '../../components/NotTaxDeductibleLegalText';
import { getParameterByName } from '../../utility/queryStringHelper';
import CoverFeeCheckbox from '../../components/coverFee/coverFeeCheckbox';
import {
  computeAmountAfterFee,
  isOptInCoverFee,
  restoreDonationAmount,
  updateDonationAmount,
  setFeeAmountInStore,
} from '../../components/coverFee/feeUtils';
import withDonate from '../../components/guest/WithDonate';
import withTheme from '../../components/withTheme';
import AnonymousCheckbox from '../../components/anonymousDonation/anonymousCheckbox';
import {
  getPersonalizedAnonymousContent,
  getPersonalizedNoteToPayeeLabel,
  isCheckoutRail,
  isExternalFlow,
  prepareOrderParams,
} from '../../utility/productIntegrationUtils';
import NoteComponent from '../../components/note';
import isEmpty from 'lodash/isEmpty';
import {
  trackAnonymousCheckboxClick,
  trackCoverFeeCheckboxClick,
  trackDonateWithCardClick,
  trackDonateWithPayPalClick,
  trackLandingPageIM,
  trackNextClickForCheckout,
} from '../../fpti/fpti';
import { CPL_PAGE_SPEC } from '../../fpti/fptiConstants';
import classNames from 'classnames';
import { BodyText, HeadingText } from '@paypalcorp/pp-react';
import getContent from 'pp-react-l10n';

const messages = localsMessages('common/amount');
const errorMessages = localsMessages('errors/landingerror');
const MERCHANT_PPCC_CONFIRMED_STATUS = 'CONFIRMED';
const getCampaignContent = getContent('locals')('landing')('campaigns');

class LandingPageComponent extends React.Component {
  constructor(props) {
    super(props);
    const optInStatus = AppStore.getCoverFeeOptInStatus();
    const anonymousStatusInStore = AppStore.getAnonymousStatus();
    const anonymousOptInStatus = !isEmpty(anonymousStatusInStore)
      ? anonymousStatusInStore === 'checked'
      : templateData.anonymousStatus || false;

    this.state = {
      hasLogo: templateData.hasLogo,
      subHeaderLabel: templateData.donationName,
      orgName: templateData.charityName,
      donationId: templateData.donationId,
      guestRedirectUrl: templateData.guestRedirectUrl,
      donateDisabled: false,
      recurringEnabled: templateData.recurringEnabled,
      recurringStatus: templateData.recurringStatus === 'checked',
      recurringHelpText: '',
      recurringLabel: 'Make this a monthly donation',
      rpContinue: false,
      isAuthenticated: isAuthenticatedUser(),
      memberMandatory: templateData.memberMandatory,
      programNames:
        templateData.donateContext?.program_names || templateData.programNames,
      isRecurringOverlayOpen: false,
      isVoucherFlow: templateData.isVoucherFlow,
      offerProgram: templateData.offerProgram,
      coverFeeEnabled: templateData.coverFeeEnabled,
      coverFeeOptInStatus:
        optInStatus !== undefined
          ? optInStatus === 'checked'
          : templateData.feePayer === 'consumer',
      feeAmount: '',
      formatedFeeAmount: '',
      anonymousEnabled: templateData.anonymousEnabled,
      anonymousOptInStatus,
      hasDisclaimer: hasPersonalizedMessages(GN_CONTENT_TOUCHPOINT),
    };
  }

  getPPCCConfirmation() {
    return getPPCCStatus() === MERCHANT_PPCC_CONFIRMED_STATUS;
  }

  componentDidMount = () => {
    window.onload = function () {
      setTimeout(function () {
        cpl.logPerformance(CPL_PAGE_SPEC.LANDING_PAGE);
      }, 0);
    };

    AppActions.updateCurrentPage({ currentPage: 'landing' });

    // Do not hide spinner if coming to page with already completed payment token
    if (templateData.paymentStatus !== 'complete') {
      hideSpinnerOverlay();
    }

    // Checking for recurring status if coming from guest page
    if (AppStore.getDonationRecurring() === 'checked') {
      this.setState({ recurringStatus: true });
    }

    // Checking for cover fee preference if coming from guest page
    if (isOptInCoverFee()) {
      this.setState({ coverFeeOptInStatus: true });
      restoreDonationAmount();
    }

    setFeeAmountInStore();
    this.updateFeeAmount();

    trackLandingPageIM({ noteFieldDisplayed: this.shouldShowNote() });

    // Pre-load bodyMovin
    if (templateData.recurringEnabled) {
      loadBodyMovin();
    }

    if (!isLoggedInUser()) {
      AppActions.showLanguageSelector(true);
    }

    // Register for App Dispatcher Messages
    this.registerAppDispatcherMessages();
  };

  componentWillUnmount() {
    AppDispatcher.unregister(this.dispatcherMessages);
  }

  registerAppDispatcherMessages = () => {
    this.dispatcherMessages = AppDispatcher.register((payload) => {
      if (payload.action && payload.action.actionType === 'CHANGE_RECURRING') {
        const checked = _get(payload.action, 'item', 'unchecked');
        this.setState({
          recurringStatus: checked === 'checked',
        });
      }
    });
  };

  getFPTDATA = () => {
    return {
      amount: AppStore.getDonationAmount(),
      code: AppStore.getDonationCode(),
      symbol: AppStore.getDonationSymbol(),
    };
  };

  validateAmountAndNavigateToGuestPage = () => {
    let donationAmount = AppStore.getDonationAmount();

    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      trackDonateWithCardClick({
        noteFieldDisplayed: this.shouldShowNote(),
        fptiData: {
          is_recurring: this.state.recurringStatus ? 'on' : 'off',
          fee_type: this.state.coverFeeEnabled ? 'offset' : 'none',
        },
      });
      this.props.history.push(`/donate/guest?token=${templateData.token}`);
    } else {
      addShake();
    }
  };

  handleGuest = (event) => {
    event.preventDefault();
    AppActions.changeRecurringModalStatus({
      recurringModalStatus: 'notclosed',
    });
    let donationAmount = this.getDonationAmount();
    if (!this.validateDonationAmount()) {
      return;
    }

    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      const isRecurringChecked = this.state.recurringStatus;

      if (isRecurringChecked && !this.state.memberMandatory) {
        this.openRecurringOverlay();
      } else {
        this.validateAmountAndNavigateToGuestPage();
      }

      // Start CPL tracking to get measurements to load guest form
      window.PAYPAL.analytics.startCPLTracking({
        page: 'main:donate:wps:guest:guestform:guestFormComponent:web::',
        action: 'guest_form_loaded',
        uicomp: 'guestForm',
        uitype: 'component',
      });
    }
  };

  handleNext = (event) => {
    event.preventDefault();
    if (!this.validateDonationAmount()) {
      return;
    }

    let donationAmount = this.getDonationAmount();
    if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
      trackDonateWithPayPalClick({
        noteFieldDisplayed: this.shouldShowNote(),
        fptiData: {
          is_recurring: this.state.recurringStatus ? 'on' : 'off',
          fee_type: this.state.coverFeeEnabled ? 'offset' : 'none',
        },
      });
      handleLogIn();
    }
  };

  handleNextForCheckout = (event) => {
    event.preventDefault();
    if (!this.validateDonationAmount()) {
      return;
    }

    trackNextClickForCheckout({ noteFieldDisplayed: this.shouldShowNote() });
    showSpinnerOverlay();
    const orderParams = prepareOrderParams();
    this.props.createOrder(orderParams);
  };

  getDonationAmount = () => {
    let donationAmount = AppStore.getDonationAmount();

    if (isOptInCoverFee()) {
      const feeAmount = AppStore.getFeeAmount();
      // backup user's original entered amount in store
      AppActions.changeAmountBeforeFee({ amountBeforeFee: donationAmount });

      if (feeAmount) {
        donationAmount = computeAmountAfterFee(donationAmount, feeAmount);
        updateDonationAmount(donationAmount);
      }
    }

    return donationAmount;
  };

  hideValidationError = () => {
    this.setState({
      showValidationError: false,
    });
  };

  validateDonationAmount = () => {
    let validationResult = amountUtils.validateMinimumDonationAmount(messages);
    if (validationResult?.showValidationError) {
      this.setState(validationResult);
      addShake();
      return false;
    }

    validationResult = amountUtils.validateMaximumDonationAmount();
    if (validationResult?.showValidationError) {
      this.setState(validationResult);
      addShake();
      return false;
    }

    this.setState(validationResult);
    return true;
  };

  handleAmountFocus = () => {
    if (this.state.showValidationError) {
      this.hideValidationError();
    }
  };

  updateConversionSataus = (status = false) => {
    this.setState({ donateDisabled: status });
  };

  handleRecurringChange = (status = false) => {
    this.setState({ recurringStatus: status });
    console.log('status ', status);
  };

  handleRecurringOverlayContinue = () => {
    this.setState({ rpContinue: true });
    this.validateAmountAndNavigateToGuestPage();
  };

  handleRecurringOverlayMakeOneTimeDonation = () => {
    AppActions.changeRecurring({
      recurring: 'unchecked',
    });
    this.validateAmountAndNavigateToGuestPage();
  };

  handleAnonymousDonationChange = (status = false) => {
    this.setState({ anonymousOptInStatus: status });
    trackAnonymousCheckboxClick(status);
  };

  handleCoverFeeChange = (status = false) => {
    this.setState({ coverFeeOptInStatus: status });
    trackCoverFeeCheckboxClick(status);
  };

  updateFeeAmount = () => {
    this.setState({
      feeAmount: AppStore.getFeeAmount(),
      formatedFeeAmount: AppStore.getFormatedFeeAmount(),
    });
  };

  openRecurringOverlay = () => {
    this.setState({
      isRecurringOverlayOpen: true,
    });
  };

  closeRecurringOverlay = () => {
    this.setState({
      isRecurringOverlayOpen: false,
    });
  };

  renderProgramsDropdown = () => {
    if (isOldButtonFactory() || _isEmpty(this.state.programNames)) {
      return null;
    }

    return <Programs programNames={this.state.programNames} />;
  };

  renderDonateButtons = () => {
    if (isCheckoutRail()) {
      return (
        <OneTouchNextButton
          disabled={false}
          handleNext={this.handleNextForCheckout}
        />
      );
    }

    if (this.state.isAuthenticated) {
      return (
        <OneTouchNextButton
          disabled={this.state.donateDisabled}
          handleNext={this.handleNext}
        />
      );
    }

    return (
      <div>
        <div className="mb-16">
          <NextButton
            disabled={this.state.donateDisabled}
            handleNext={this.handleNext}
          />
        </div>
        <GuestButton
          disabled={this.state.donateDisabled}
          handleGuest={this.handleGuest}
        />
      </div>
    );
  };

  /**
   * Should show note on landing page when charityNote is enabled
   * and recurring is disabled for client flows
   * @return {Boolean} true to show note field
   */
  shouldShowNote = () => {
    return (
      templateData.charityNoteEnabled &&
      !this.state.recurringStatus &&
      isExternalFlow()
    );
  };

  getPersonalizedContent = () => {
    if (isExternalFlow()) {
      const personalizedMessages = getPersonalizedMessages(
        GN_CONTENT_TOUCHPOINT
      );
      return personalizedMessages?.disclaimer;
    }
  };

  landingClass() {
    return classNames({
      gn_donate_wrapper: templateData.bannerUrl,
      donate_wrapper: !templateData.bannerUrl,
      context_gn_wrapper: isInContext(),
      'user-banner': shouldShowUserBanner(),
      mobile_view: isMobileOrInContext(),
    });
  }

  shouldShowSupportText = () => {
    const amountRaised = templateData.campaignTotalAmountRaised || '0';
    const campaignStatus = templateData.campaignStatus;
    return (
      campaignStatus === 'INACTIVE' &&
      +amountRaised >= +templateData.campaignTargetAmount
    );
  };

  shouldShowNoDonationText = () => {
    const amountRaised = templateData.campaignTotalAmountRaised || '0';
    const campaignStatus = templateData.campaignStatus;
    return (
      campaignStatus === 'INACTIVE' &&
      ((!templateData.campaignEndTime && amountRaised === '0') ||
        templateData.campaignEndTime !== '')
    );
  };

  render() {
    const showUserBanner = shouldShowUserBanner();
    const showSupportText = this.shouldShowSupportText();
    const showNoDonationText = this.shouldShowNoDonationText();

    if (!templateData.receiverCountryEligible) {
      return (
        <div
          className={`donate_wrapper receiver-eligibility-error-container ${
            isMobileOrInContext() ? 'mobile_view' : ''
          }`}
        >
          <ReceiverEligibilityErrorTile
            errorMessages={errorMessages}
            organizationName={templateData.donationName}
            returnUrl={templateData.charityReturnUrl}
          />
        </div>
      );
    }

    return (
      <div>
        <div className={this.landingClass()}>
          {showUserBanner && !showNoDonationText && !showSupportText ? (
            <UserDetailsBanner userDetails={templateData.userDetails} />
          ) : null}
          {isExternalFlow() && <CloseButton inverse />}
          <DonateHeader isLanding={true} />
          {(() => {
            switch (true) {
              case showSupportText:
                return (
                  <HeadingText
                    size="sm"
                    className="text-center text-padding-top"
                  >
                    {getCampaignContent('supportText')}
                  </HeadingText>
                );
              case showNoDonationText:
                return (
                  <BodyText className="text-center text-padding-top">
                    {getCampaignContent('noDonationText')}
                  </BodyText>
                );
              default:
                return (
                  <div
                    className={classNames({
                      container: true,
                      campaigns: isCampaigns(),
                    })}
                  >
                    <AmountWrapper
                      conversionStatus={this.updateConversionSataus}
                      validateDonationAmount={this.validateDonationAmount}
                      showValidationError={this.state.showValidationError}
                      hideValidationError={this.hideValidationError}
                      validationErrorMessage={this.state.validationErrorMessage}
                      validationErrorCode={this.state.validationErrorCode}
                      onFocus={this.handleAmountFocus}
                      updateFeeAmount={this.updateFeeAmount}
                    />
                    {this.renderProgramsDropdown()}
                    {!isCampaigns() && this.state.anonymousEnabled && (
                      <AnonymousCheckbox
                        content={getPersonalizedAnonymousContent()}
                        optInStatus={this.state.anonymousOptInStatus}
                        handleAnonymousDonationChange={
                          this.handleAnonymousDonationChange
                        }
                      />
                    )}
                    {this.shouldShowNote() && (
                      <NoteComponent
                        label={getPersonalizedNoteToPayeeLabel()}
                      />
                    )}
                    {this.state.coverFeeEnabled && (
                      <CoverFeeCheckbox
                        handleCoverFeeChange={this.handleCoverFeeChange}
                        optInStatus={this.state.coverFeeOptInStatus}
                        formatedFeeAmount={this.state.formatedFeeAmount}
                      />
                    )}
                    {this.state.recurringEnabled && (
                      <RecurringCheckBox
                        status={this.state.recurringStatus}
                        handleChange={this.handleRecurringChange}
                        showNote={false}
                        hasRecurringHelp={true}
                        continue={this.state.rpContinue}
                      />
                    )}
                    {this.state.isVoucherFlow && (
                      <OfferDetail
                        offerProgram={this.state.offerProgram}
                        success={false}
                      />
                    )}
                    {this.renderDonateButtons()}
                    {this.state.isVoucherFlow && <VoucherFlowDisclaimer />}
                    {hasPartnerSource() &&
                      !this.getPPCCConfirmation() &&
                      !this.state.isVoucherFlow && (
                        <NotTaxDeductibleLegalText />
                      )}
                    <RecurringOverlay
                      onContinue={this.handleRecurringOverlayContinue}
                      onMakeOneTimeDonation={
                        this.handleRecurringOverlayMakeOneTimeDonation
                      }
                      isOpen={this.state.isRecurringOverlayOpen}
                      openRecurringOverlay={this.openRecurringOverlay}
                      closeRecurringOverlay={this.closeRecurringOverlay}
                    />
                    {this.state.hasDisclaimer && (
                      <Disclaimer content={this.getPersonalizedContent()} />
                    )}
                  </div>
                );
            }
          })()}
        </div>
        <CancelAndReturn />
      </div>
    );
  }
}

const LandingPage = withRouter(withDonate(withTheme(LandingPageComponent)));

class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      displayLanding: !templateData.currentState,
    };
  }

  /**
   * For DIRECT(nonWebscr) and POST integrations, there will not be a token in the URL
   * This will break page refresh.
   * Hence adding token here
   */
  addTokenToUrlIfMissing() {
    const token = getParameterByName('token');
    const business = getParameterByName('business');
    const hostedButtonId = getParameterByName('hosted_button_id');
    const campaignId = getParameterByName('campaign_id');

    if (!token && !business && !hostedButtonId && !campaignId) {
      this.props.history.replace({
        pathname: '/donate',
        search: `?token=${templateData.token}`,
      });
    }
  }

  componentDidMount() {
    if (!this.state.displayLanding) {
      this.props.history.push(templateData.currentState);
    } else {
      handleTokenReuse();
    }
    this.addTokenToUrlIfMissing();
  }

  render() {
    return <div>{this.state.displayLanding ? <LandingPage /> : null}</div>;
  }
}

export default withRouter(Landing);
